import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const ApplicantFilter = ({ label = "l.searchFilter.applicant", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"applicant"} label={label} {...others} />
    </>
  );
};

export default ApplicantFilter;
